import Vue from 'vue'
import VueRouter from 'vue-router'

import vuexStore from '@/store'
import {
  AUTH_REFRESH,
  STORE_REQUEST,
  STORE_LOADING_STOP,
  PREPARE_TRIAL,
  PREPARE_CLAIM_CODE
} from '@/store/types'
// Auth

// Store
import Store from '@/views/store/Store'
import Enotes from '@/views/store/Enotes'
import EnoteDetail from '@/views/store/EnoteDetail'
import BooksCategory from '@/views/store/BooksCategory'
import BooksEvent from '@/views/store/BooksEvent'
import CategoryBooks from '@/views/store/CategoryBooks'
import BookDetail from '@/views/store/BookDetail'
import Search from '@/views/store/Search'

// Cart
import Cart from '@/views/cart/Cart'
import DeliveryInfo from '@/views/cart/DeliveryInfo'
import OrderSuccessful from '@/views/cart/OrderSuccessful'

// Library
import Library from '@/views/library/Library'
import LibraryIntro from '@/views/intro/LibraryIntro'
import MyNotes from '@/views/library/MyNotes'
import MyNoteDetail from '@/views/library/MyNoteDetail'
import LibraryBookDetail from '@/views/library/LibraryBookDetail'

// Selfbook
import Selfbook from '@/views/selfbook/Selfbook'
import SelfbookIntro from '@/views/intro/SelfbookIntro'
import SelfbookCreate from '@/views/selfbook/SelfbookCreate'
import SelfbookUpload from '@/views/selfbook/SelfbookUpload'
import SelfbookModify from '@/views/selfbook/SelfbookModify'
import SelfbookDetail from '@/views/selfbook/SelfbookDetail'

// Account Tabs
import Orders from '@/views/member/Orders'
import Returns from '@/views/member/Returns'
import PostPresent from '@/views/member/PostPresent'
import Reviews from '@/views/member/Reviews'
import Gift from '@/views/member/Gift'
import Coupon from '@/views/member/Coupon'
import CouponSecond from '@/views/member/CouponSecond'
import Discount from '@/views/member/Discount'
import SelfbookSales from '@/views/member/SelfbookSales'

// Account-related Sub Pages
import LoginToEdit from '@/views/member/LoginToEdit'
import EditAccount from '@/views/member/EditAccount'
import CloseAccount from '@/views/member/CloseAccount'
// Account -> Order-related sub pages
// single order item tracking
import OrderTracking from '@/views/member/OrderTracking'
// full order tracking
import OrderDetail from '@/views/member/OrderDetail'
import RequestReturn from '@/views/member/RequestReturn'
// Account -> New Seller registration
//// New Seller Signup
import SellerStep1 from '@/views/member/seller/SellerStep1'
import SellerStep2 from '@/views/member/seller/SellerStep2'
import SellerStep3 from '@/views/member/seller/SellerStep3'
//// Seller pages
import EditBankAccount from '@/views/member/seller/EditBankAccount'
import RequestPayout from '@/views/member/seller/RequestPayout'

// Help
import CustomerCenter from '@/views/help/CustomerCenter'
import Faq from '@/views/help/Faq'
import Guide from '@/views/help/Guide'
import Partnership from '@/views/help/Partnership'
import GiftRequestGuide from '@/views/help/GiftRequestGuide'
import Notices from '@/views/help/Notices'
import CompanyIntro from '@/views/help/CompanyIntro'
import CompanyAbout from '@/views/help/CompanyAbout'
import Present from '@/views/help/Present'
import Events from '@/views/help/Events'
import TermEvent from '@/views/event/TermEvent'
import ExamEvent from '@/views/event/ExamEvent'
import CompetitionEvent from '@/views/event/CompetitionEvent.vue'
import NewsLetters from '@/views/help/NewsLetters'
import Privacy from '@/views/help/Privacy'
import Terms from '@/views/help/Terms'
import Sitemap from '@/views/help/Sitemap'

// Auth
//// LOGIN
import Login from '@/views/auth/login/Login'
import IdLost from '@/views/auth/login/IdLost'
import IdFound from '@/views/auth/login/IdFound'
import PasswordLost from '@/views/auth/login/PasswordLost'
import PasswordTemp from '@/views/auth/login/PasswordTemp'
import PasswordChange from '@/views/auth/login/PasswordChange'

//// JOIN
import SignUp from '@/views/auth/join/SignUp'
import JoinComplete from '@/views/auth/join/JoinComplete'
import JoinStep1 from '@/views/auth/join/JoinStep1'
import JoinStep2 from '@/views/auth/join/JoinStep2'
import AuthPhone from '@/views/auth/join/AuthPhone'
import AuthEmail from '@/views/auth/join/AuthEmail'
import JoinStep3 from '@/views/auth/join/JoinStep3'
import JoinStep4 from '@/views/auth/join/JoinStep4'

// Other
import Maintenance from '@/views/Maintenance'
import PageNotFound from '@/views/PageNotFound'

// TestPage
import AutoTrialReceiveBookfair from '@/views/event/AutoTrialReceiveBookfair'
import AutoTrialReceive from '@/views/event/AutoTrialReceive'
import OAuth2 from '@/views/auth/oauth2/oauth2'

// EDITOR

import NewRequestReturn from '@/views/member/NewRequestReturn'
// Payment
import PaymentSuccess from '@/views/cart/PaymentSuccess'
import PaymentFail from '@/views/cart/PaymentFail'

import Claim from '@/views/event/Claim.vue'
import { PREPARE_CLAIM_TYPE } from './store/types'

Vue.use(VueRouter)

const routes = [
  // STORE
  {
    path: '/',
    name: 'store',
    component: Store
  },
  {
    path: '/store/enotes',
    name: 'enotes',
    component: Enotes,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/store/enotes/:id',
    name: 'enote_detail',
    component: EnoteDetail,
    meta: {
      requiresAuth: true
    }
  },
  // Library
  {
    path: '/library',
    name: 'library_default',
    component: Library,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/library/intro',
    name: 'library_intro',
    component: LibraryIntro
  },
  {
    path: '/library/:id',
    name: 'library',
    component: Library,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/library/book/:id',
    name: 'library_book_detail',
    component: LibraryBookDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/my_notes',
    name: 'my_notes',
    component: MyNotes,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/store/books/category/:category',
    name: 'books_category',
    component: BooksCategory
  },
  {
    path: '/store/books/event/:order',
    name: 'books_event',
    component: BooksEvent
  },
  {
    path: '/store/:category/books/:subCategory',
    name: 'category_books',
    component: CategoryBooks
  },
  {
    path: '/store/books/:id',
    name: 'book_detail',
    component: BookDetail
  },
  {
    path: '/mynotes/:id',
    name: 'my_note_detail',
    component: MyNoteDetail
  },
  // Search
  {
    path: '/search',
    name: 'search',
    component: Search
  },
  // **************************************************************************************************
  // NOTE: DO NOT REMOVE /cart/ path prefix or it will prevent removal of header & footer on cart pages
  // **************************************************************************************************
  // Cart
  {
    path: '/cart',
    name: 'cart',
    component: Cart,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cart/delivery_info',
    name: 'delivery_info',
    component: DeliveryInfo,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cart/order_successful',
    name: 'order_successful',
    component: OrderSuccessful,
    meta: {
      requiresAuth: true
    }
  },

  // SELFBOOK
  {
    path: '/selfbook',
    name: 'selfbook',
    component: Selfbook,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/selfbook/intro',
    name: 'selfbook_intro',
    component: SelfbookIntro
  },
  {
    path: '/selfbook/create',
    name: 'selfbook_create',
    component: SelfbookCreate,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/selfbook/upload',
    name: 'selfbook_upload',
    component: SelfbookUpload,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/selfbook/:id',
    name: 'selfbook_detail',
    component: SelfbookDetail
  },
  {
    // If user is creator of selfbook, route to /modify/:id
    path: '/selfbook/modify/:id',
    name: 'selfbook_modify',
    component: SelfbookModify,
    meta: {
      requiresAuth: true
    }
  },
  // AUTH
  // ACCOUNT PAGE TABS
  {
    path: '/account',
    name: 'orders',
    component: Orders,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/returns',
    name: 'returns',
    component: Returns,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/request_return',
    name: 'NewRequestReturn',
    component: NewRequestReturn,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/reviews',
    name: 'reviews',
    component: Reviews,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/gift',
    name: 'gift',
    component: Gift,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/coupon',
    name: 'coupon',
    component: Coupon,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/discount',
    name: 'discount',
    component: Discount,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/login/id_lost',
    name: 'id_lost',
    component: IdLost,
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/login/id_found',
    name: 'id_found',
    component: IdFound,
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/login/password_lost',
    name: 'password_lost',
    component: PasswordLost,
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/login/password_change/:updateHash',
    name: 'password_change',
    component: PasswordChange
  },
  {
    path: '/login/password_temp',
    name: 'password_temp',
    component: PasswordTemp
  },
  {
    path: '/join/sign_up',
    name: 'sign_up',
    component: SignUp
  },
  {
    path: '/join/step1',
    name: 'join_step1',
    component: JoinStep1
  },
  {
    path: '/join/step2',
    name: 'join_step2',
    component: JoinStep2
  },
  {
    path: '/join/auth_phone',
    name: 'auth_phone',
    component: AuthPhone
  },
  {
    path: '/join/auth_email',
    name: 'auth_email',
    component: AuthEmail
  },
  {
    path: '/join/step3',
    name: 'join_step3',
    component: JoinStep3
  },
  {
    path: '/join/step4',
    name: 'join_step4',
    component: JoinStep4
  },
  {
    path: '/join/join_complete',
    name: 'join_complete',
    component: JoinComplete
  },
  // SELFBOOK SALES-RELATED
  {
    path: '/account/selfbook_sales',
    name: 'selfbook_sales',
    component: SelfbookSales,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/request_payout',
    name: 'request_payout',
    component: RequestPayout,
    meta: {
      requiresAuth: true
    }
  },
  // ACCOUNT-RELATED PAGES
  {
    path: '/account/login_to_edit',
    name: 'login_to_edit',
    component: LoginToEdit
  },
  {
    path: '/account/edit',
    name: 'edit_account',
    component: EditAccount,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/edit_bank_account',
    name: 'edit_bank_account',
    component: EditBankAccount,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/delete',
    name: 'close_account',
    component: CloseAccount,
    meta: {
      requiresAuth: true
    }
  },
  // ACCOUNT -> SELLER REGISTRATION
  {
    path: '/seller/step1',
    name: 'seller_step1',
    component: SellerStep1
  },
  {
    path: '/seller/step2',
    name: 'seller_step2',
    component: SellerStep2
  },
  {
    path: '/seller/step3',
    name: 'seller_step3',
    component: SellerStep3
  },
  // ACCOUNT ORDER SUB PAGES
  {
    // Detail page for WHOLE order. Use order_tracking for individual order shipping tracking
    path: '/account/order_detail/:id',
    name: 'order_detail',
    component: OrderDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/order_tracking',
    name: 'order_tracking',
    component: OrderTracking,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account/request_return',
    name: 'request_return',
    component: RequestReturn,
    meta: {
      requiresAuth: true
    }
  },
  // HELP
  {
    path: '/help',
    name: 'customer_center',
    component: CustomerCenter
  },
  {
    path: '/help/faq',
    name: 'faq',
    component: Faq
  },
  {
    path: '/help/notices',
    name: 'notices',
    component: Notices
  },
  {
    path: '/help/guide',
    name: 'guide',
    component: Guide
  },
  {
    path: '/help/GiftRequestGuide',
    name: 'GiftRequestGuide',
    component: GiftRequestGuide
  },
  {
    path: '/help/Partnership',
    name: 'Partnership',
    component: Partnership
  },
  {
    path: '/help/privacy',
    name: 'privacy',
    component: Privacy
  },
  {
    path: '/help/terms',
    name: 'terms',
    component: Terms
  },
  {
    path: '/help/company_intro',
    name: 'company_intro',
    component: CompanyIntro
  },
  {
    path: '/help/CompanyAbout',
    name: 'CompanyAbout',
    component: CompanyAbout
  },
  {
    path: '/help/present',
    name: 'present',
    component: Present,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/help/present/post',
    name: 'postPresent',
    component: PostPresent,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/help/couponSecond',
    name: 'couponSecond',
    component: CouponSecond,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/events/:eventCd?',
    name: 'events',
    component: Events
  },
  {
    path: '/event/term_event/:id',
    name: 'term_event',
    component: TermEvent,
    props: true
  },
  {
    path: '/event/exam_event',
    name: 'exam_event',
    component: ExamEvent
  },
  {
    path: '/event/competition_event/:id',
    name: 'competition_event',
    component: CompetitionEvent,
    props: true
  },
  {
    path: '/newsletters/:newsletterCd?',
    name: 'newsletters',
    component: NewsLetters
  },
  {
    path: '/help/sitemap',
    name: 'sitemap',
    component: Sitemap
  },

  {
    path: '/maintenance',
    name: 'maintenance',
    component: Maintenance
  },
  {
    path: '*',
    name: '404',
    component: PageNotFound
  },
  {
    path: '/qrcode/trial/bookfair2024/:code',
    name: 'trial_bookfair',
    component: AutoTrialReceiveBookfair,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/qrcode/trial/:code',
    name: 'trial',
    component: AutoTrialReceive,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login/oauth2/code/:provider',
    name: 'oauth2',
    component: OAuth2
  },
  {
    path: '/payment/success',
    name: 'PaymentSuccess',
    component: PaymentSuccess
  },
  {
    path: '/payment/fail',
    name: 'PaymentFail',
    component: PaymentFail
  },
  {
    path: '/claim/:type',
    name: 'Claim',
    component: Claim,
    meta: {
      requiresAuth: true
    }
  }
]
const originalPush = VueRouter.prototype.push

// wcs_add 및 _nasa 객체를 Vue 인스턴스의 데이터로 정의합니다.
Vue.prototype.$wcs_add = { wa: 's_1512e65d4360' }
Vue.prototype.$_nasa = {}

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  vuexStore.commit(STORE_REQUEST)
  if (to.name !== 'login') {
    vuexStore.commit('beforeRouteName', to)
  }

  if (to.name === 'trial') {
    vuexStore.commit(PREPARE_TRIAL, to.params.code)
  } else if (localStorage.getItem('trialCode') != null) {
    vuexStore.commit(PREPARE_TRIAL, localStorage.getItem('trialCode'))
  }

  if (to.name === 'Claim' && to.query.code) {
    vuexStore.commit(PREPARE_CLAIM_TYPE, to.params.type)
    vuexStore.commit(PREPARE_CLAIM_CODE, to.query.code)
  } else if (sessionStorage.getItem('claim_code') != null) {
    vuexStore.commit(PREPARE_CLAIM_TYPE, sessionStorage.getItem('claim_type'))
    vuexStore.commit(PREPARE_CLAIM_CODE, sessionStorage.getItem('claim_code'))
  }

  if (to.meta.requiresAuth && !vuexStore.getters.getCurrentUser) {
    if (from.path === '/login') {
      return next()
    }
    try {
      console.log('r-issue')
      await vuexStore.dispatch(AUTH_REFRESH)
      next()
    } catch (err) {
      next({ name: 'login' })
    }
  } else {
    next()
  }
  if (to.meta.requiresGuest && vuexStore.getters.getCurrentUser) {
    next({ name: 'store' })
  } else {
    next()
  }
})
router.afterEach((to) => {
  vuexStore.commit(STORE_LOADING_STOP)

  // 구매완료
  if (to.path === '/cart/order_successful') {
    if (window.wcs) {
      var _nasa = {}
      _nasa['cnv'] = window.wcs.cnv('2', '1') // 적절히 변경
      window.wcs_do(_nasa)
    }
  }
  // 회원가입
  if (to.path === '/join/step4') {
    if (window.wcs) {
      _nasa = {}
      _nasa['cnv'] = window.wcs.cnv('2', '0') // 적절히 변경
      window.wcs_do(_nasa)
    }
  }

  // wcs 객체가 정의되어 있을 때만 inflow()와 wcs_do()를 호출합니다.
  if (window.wcs) {
    window.wcs.inflow('www.campusbook.co.kr')
    window.wcs_do(Vue.prototype.$_nasa)
  }
})

export default router
